/* ── ESI contract verification helpers ── */

export async function resolveRegionId(esiBase, sysId) {
  const sr = await fetch(`${esiBase}/universe/systems/${sysId}/?datasource=tranquility&language=en`);
  if (!sr.ok) throw new Error(`Could not resolve contract region — system lookup failed (HTTP ${sr.status})`);
  const sys = await sr.json();

  const cr = await fetch(`${esiBase}/universe/constellations/${sys.constellation_id}/?datasource=tranquility&language=en`);
  if (!cr.ok) throw new Error(`Could not resolve contract region — constellation lookup failed (HTTP ${cr.status})`);
  const con = await cr.json();

  return con.region_id;
}

export async function findPublicContract(esiBase, regionId, contractId) {
  const url = (page) => `${esiBase}/contracts/public/${regionId}/?datasource=tranquility&page=${page}`;

  const r1 = await fetch(url(1));
  if (!r1.ok) throw new Error(`Failed to fetch public contracts for region ${regionId} (HTTP ${r1.status})`);
  const totalPages = parseInt(r1.headers.get("X-Pages") ?? "1", 10);
  const page1 = await r1.json();

  const restPages = await Promise.all(
    Array.from({ length: Math.max(0, totalPages - 1) }, (_, i) => i + 2).map((page) =>
      fetch(url(page))
        .then((r) => (r.ok ? r.json() : []))
        .catch(() => [])
    )
  );

  const all = [page1, ...restPages].flat();
  const want = String(contractId);
  return all.find((c) => String(c.contract_id) === want) ?? null;
}

export async function resolveStationSystem(esiBase, locationId) {
  const r = await fetch(`${esiBase}/universe/stations/${locationId}/?datasource=tranquility&language=en`);
  if (!r.ok) return null;
  const station = await r.json();
  return { systemId: station.system_id, name: station.name };
}

const TYPE_LABELS = {
  courier: "Courier",
  item_exchange: "Item Exchange",
  auction: "Auction",
  loan: "Loan",
};
export function mapContractType(esiType) {
  return TYPE_LABELS[esiType] ?? esiType;
}
